module.exports = __webpack_public_path__ + "static/media/drag_reorder_mobile.c928ca57.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/swipe/drag_reorder_mobile.mp4
// module id = 264
// module chunks = 0